<template>
  <g class="Gustavo-grid" :transform="`translate(${left}, ${top})`">
    <g class="Gustavo-grid-axes" v-if="axes">
      <g
        v-for="(axis, i) in axes"
        class="Gustavo-grid-axis"
        :key="i"
        :transform="`translate(${
          axis.props.orient === 'bottom' ? viewboxPosition.x : axis.xPos
        }, ${axis.yPos})`"
      >
        <FlexibleAxis
          v-bind="axis.props"
          :grid-key="gridKey"
          :left="left"
          :top="top"
          :xPos="axis.xPos"
          :yPos="axis.yPos"
          :chartHeight="chartHeight"
          @update:axisTickSize="$emit('update:axisTickSize', $event)"
          @update:axisSize="$emit('update:axisSize', $event)"
        />
      </g>
    </g>
  </g>
</template>

<script>
import Grid from './grid.vue';
import FlexibleAxis from '../labels/flexible-axis.vue';

export default {
  name: 'DatalasFlexibleGrid',
  extends: Grid,
  components: { FlexibleAxis },

  props: {
    viewboxPosition: {
      type: Object,
      default: () => ({ x: 0, y: 0 }),
    },
    left: { type: Number, default: 0 },
    chartHeight: { type: Number, default: 0 },
    gridKey: String,
  },
};
</script>
